
import Account from '../models/Account';
import Feature from '../models/Feature';
import Subscription from '../models/Subscription';
import request from '../shared/http';

const cache = {};


class MyAccountService {
  getURL() {
    return '/accounts/@me';
  }

  async fetch() {

      const response = await request.get(this.getURL());
      const { data } = response;
      console.log('accData', data);
      
     return new Account({
        id: data.id,
        firstName: data.first_name,
        lastName: data.last_name,
        organizationId: data.organization_id,
        timeZone: data.timezone,
        email: data.email,
        mobile: data.mobile,
        imageUpdatedAt: data.image_updated_at,
        subscription: new Subscription({
          status: data.subscription?.status,
          planId: data.subscription?.plan_id,
          endDate: data.subscription?.end_date,
          subscriptionId: data.subscription?.subscription_id,
        }),
        allowedFeatures: data.allowed_features?.map((df) => new Feature({
          id: df?.id,
          featureName: df?.feature_name,
          limit: df?.limit,
          units: df?.units,
          featureId: df?.feature_id,
        })),
      });
  }

  get() {
    return cache.account;
  }

  async updateAccount({
    firstName,
    lastName,
    timeZone,
    imageUpdatedAt,
  }) {
    const response = await request.put(this.getURL(), {
      first_name: firstName,
      last_name: lastName,
      locale: 'En',
      timezone: timeZone,
    });
    cache.account.setFirstName(firstName);
    cache.account.setLastName(lastName);
    cache.account.setTimeZone(timeZone);
    cache.account.setImageUpdatedAt(imageUpdatedAt);
    return response;
  }

  async updateMedia({ accountId, file }) {
    const formData = new FormData();
    formData.append('file', file);
    const url = `/accounts/${accountId}/image`;
    return request.put(
      url,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      },
    );
  }

  async deleteMedia(accountId) {
    const url = `/accounts/${accountId}/image`;
    return request.delete(url);
  }

  async updateAccountPassword({ currentPassword, newPassword }) {
    return request.put(`${this.getURL()}/password`, {
      current_password: currentPassword,
      next_password: newPassword,
    });
  }

  updateAccountEmail(email) {
    return request.put(`${this.getURL()}/email`, { email });
  }

  updateAccountMobile(mobile) {
    return request.put(`${this.getURL()}/mobile`, { mobile });
  }
}

export default new MyAccountService();
